import axios from '@/plugins/axios';

export async function all(){
    return await axios.get('debts-api');
}

export async function setWebHook(service, url){
    return await axios.post('debts-api', {service, url});
}

export async function deleteWebHook(service){
    return await axios.delete('debts-api', {params: {service}});
}